import { useEffect } from 'react';

import { useFeature } from '@sendpayments/react-shared/hooks/useFeature';
import { PD_4823_REBRANDING_2025 } from '@sendpayments/shared-constants/features';

export const useFavicon = () => {
  const [
    {
      data: { isEnabled: isRebrandActive },
    },
  ] = useFeature({
    feature: PD_4823_REBRANDING_2025,
    activeValue: undefined,
    functionName: `Captcha`,
    defaultValue: undefined,
  });
  const fileType = isRebrandActive ? '.svg' : '.ico';
  const iconLocation = isRebrandActive ? `legacy/themes/${process.env.PROJECT_NAME}/images/rebrand` : 'static/';
  const faviconUrl = `${iconLocation}favicon${fileType}`;

  useEffect(() => {
    if (process.env.PROJECT_NAME !== 'sendpayments') {
      return;
    }

    const existingLink = document.querySelector("link[rel*='icon']");

    if (existingLink) {
      existingLink.setAttribute('href', faviconUrl);
    } else {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = faviconUrl;
      document.head.appendChild(newLink);
    }
  }, [faviconUrl]);
};
